import { Service, signal } from '@angular/core';

@Service()
export class DebugModeService {
    private readonly _isActive = signal<boolean>(false);
    public readonly isActive = this._isActive.asReadonly();

    private readonly raxDebugKeyCacheKey = 'rax-debug-key';
    public readonly _debugKey = signal<string>(localStorage.getItem(this.raxDebugKeyCacheKey) ?? '');
    public readonly debugKey = this._debugKey.asReadonly();

    public setIsActive(isActive: boolean): void {
        this._isActive.set(isActive);
    }

    public setDebugKey(debugKey: string): void {
        this.setRaxDebugKeyInLocalStorage(this.raxDebugKeyCacheKey, debugKey);
        this._debugKey.set(debugKey);
    }

    public clearDebugKey(): void {
        localStorage.removeItem(this.raxDebugKeyCacheKey);
        this._debugKey.set('');
    }

    private setRaxDebugKeyInLocalStorage(raxDebugKeyCacheKey: string, raxDebugKeyValue: string): void {
        if (raxDebugKeyValue?.length > 0) {
            localStorage.setItem(raxDebugKeyCacheKey, raxDebugKeyValue);
        } else {
            localStorage.removeItem(raxDebugKeyCacheKey);
        }
    }
}
